export const mockMutualFunds = [
  {
    id: 1,
    name: "SBI Gold Fund",
    category: "Commodities",
    rating: 5,
    returns: {
      "3Y": 31.99,
      "5Y": 25.45,
      "7Y": 20.11
    }
  },
  {
    id: 2,
    name: "Parag Parikh Flexi Cap Fund",
    category: "Equity Flexi Cap",
    rating: 5,
    returns: {
      "3Y": 22.47,
      "5Y": 28.98,
      "7Y": 24.32
    }
  },
  {
    id: 3,
    name: "Motilal Oswal Midcap Fund",
    category: "Equity Mid Cap",
    rating: 5,
    returns: {
      "3Y": 27.74,
      "5Y": 32.11,
      "7Y": 26.54
    }
  },
  {
    id: 4,
    name: "Bandhan Small Cap Fund",
    category: "Equity Small Cap",
    rating: 4,
    returns: {
      "3Y": 32.98,
      "5Y": 35.12,
      "7Y": 29.87
    }
  },
  {
    id: 5,
    name: "HDFC Flexi Cap Fund",
    category: "Equity Flexi Cap",
    rating: 5,
    returns: {
      "3Y": 23.47,
      "5Y": 29.87,
      "7Y": 25.01
    }
  },
  {
    id: 6,
    name: "JioBlackRock Flexi Cap Fund",
    category: "Equity Flexi Cap",
    rating: 4,
    returns: {
      "3Y": null,
      "5Y": 22.87,
      "7Y": 19.45
    }
  },
  {
    id: 7,
    name: "Edelweiss US Technology Equity FoF Fund",
    category: "Equity International",
    rating: 4,
    returns: {
      "3Y": 39.34,
      "5Y": 42.11,
      "7Y": 35.98
    }
  },
  {
    id: 8,
    name: "ICICI Prudential Bluechip Fund",
    category: "Equity Large Cap",
    rating: 5,
    returns: {
      "3Y": 18.5,
      "5Y": 22.3,
      "7Y": 19.8
    }
  },
  {
    id: 9,
    name: "Axis Small Cap Fund",
    category: "Equity Small Cap",
    rating: 4,
    returns: {
      "3Y": 29.8,
      "5Y": 33.1,
      "7Y": 28.5
    }
  },
  {
    id: 10,
    name: "Mirae Asset Large Cap Fund",
    category: "Equity Large Cap",
    rating: 5,
    returns: {
      "3Y": 19.2,
      "5Y": 23.5,
      "7Y": 20.1
    }
  },
  {
    id: 11,
    name: "Kotak Bluechip Fund",
    category: "Equity Large Cap",
    rating: 4,
    returns: {
      "3Y": 17.9,
      "5Y": 21.8,
      "7Y": 18.9
    }
  },
  {
    id: 12,
    name: "DSP Midcap Fund",
    category: "Equity Mid Cap",
    rating: 4,
    returns: {
      "3Y": 25.1,
      "5Y": 29.8,
      "7Y": 24.7
    }
  },
  {
    id: 13,
    name: "Franklin U.S. Opportunities Fund",
    category: "Equity International",
    rating: 3,
    returns: {
      "3Y": 33.5,
      "5Y": 38.2,
      "7Y": 32.1
    }
  },
  {
    id: 14,
    name: "Nippon India Small Cap Fund",
    category: "Equity Small Cap",
    rating: 4,
    returns: {
      "3Y": 31.2,
      "5Y": 34.5,
      "7Y": 30.1
    }
  },
  {
    id: 15,
    name: "UTI Flexi Cap Fund",
    category: "Equity Flexi Cap",
    rating: 4,
    returns: {
      "3Y": 21.9,
      "5Y": 27.4,
      "7Y": 23.5
    }
  },
  {
    id: 16,
    name: "Aditya Birla Sun Life Frontline Equity Fund",
    category: "Equity Large Cap",
    rating: 4,
    returns: {
      "3Y": 18.1,
      "5Y": 22.0,
      "7Y": 19.2
    }
  },
  {
    id: 17,
    name: "Invesco India Contra Fund",
    category: "Equity Contra",
    rating: 4,
    returns: {
      "3Y": 24.8,
      "5Y": 29.1,
      "7Y": 25.3
    }
  },
  {
    id: 18,
    name: "Tata Digital India Fund",
    category: "Sectoral Funds",
    rating: 3,
    returns: {
      "3Y": 28.9,
      "5Y": 33.8,
      "7Y": 29.4
    }
  },
  {
    id: 19,
    name: "Canara Robeco Bluechip Equity Fund",
    category: "Equity Large Cap",
    rating: 4,
    returns: {
      "3Y": 19.8,
      "5Y": 24.1,
      "7Y": 21.0
    }
  },
  {
    id: 20,
    name: "HSBC Midcap Fund",
    category: "Equity Mid Cap",
    rating: 3,
    returns: {
      "3Y": 26.2,
      "5Y": 30.5,
      "7Y": 25.8
    }
  },
  {
    id: 21,
    name: "L&T Midcap Fund",
    category: "Equity Mid Cap",
    rating: 4,
    returns: {
      "3Y": 27.1,
      "5Y": 31.8,
      "7Y": 26.9
    }
  },
  {
    id: 22,
    name: "PGIM India Midcap Opportunities Fund",
    category: "Equity Mid Cap",
    rating: 4,
    returns: {
      "3Y": 28.3,
      "5Y": 32.9,
      "7Y": 28.1
    }
  },
  {
    id: 23,
    name: "SBI Contra Fund",
    category: "Equity Contra",
    rating: 4,
    returns: {
      "3Y": 25.5,
      "5Y": 30.1,
      "7Y": 26.2
    }
  },
  {
    id: 24,
    name: "IDFC Sterling Value Fund",
    category: "Equity Value",
    rating: 4,
    returns: {
      "3Y": 23.1,
      "5Y": 28.5,
      "7Y": 24.3
    }
  },
  {
    id: 25,
    name: "Templeton India Value Fund",
    category: "Equity Value",
    rating: 3,
    returns: {
      "3Y": 22.5,
      "5Y": 27.8,
      "7Y": 23.9
    }
  },
  {
    id: 26,
    name: "ICICI Prudential Value Discovery Fund",
    category: "Equity Value",
    subCategory: "High Return",
    rating: 5,
    returns: {
      "3Y": 24.1,
      "5Y": 29.5,
      "7Y": 25.8
    }
  },
  {
    id: 27,
    name: "HDFC Top 100 Fund",
    category: "Equity Large Cap",
    rating: 4,
    returns: {
      "3Y": 17.5,
      "5Y": 21.2,
      "7Y": 18.5
    }
  },
  {
    id: 28,
    name: "Baroda BNP Paribas Large Cap Fund",
    category: "Equity Large Cap",
    rating: 3,
    returns: {
      "3Y": 16.9,
      "5Y": 20.8,
      "7Y": 18.1
    }
  },
  {
    id: 29,
    name: "Quant Small Cap Fund",
    category: "Equity Small Cap",
    subCategory: "High Return",
    rating: 5,
    returns: {
      "3Y": 35.8,
      "5Y": 40.2,
      "7Y": 34.9
    }
  },
  {
    id: 30,
      name: "Tata Small Cap Fund",
      category: "Equity Small Cap",
      rating: 4,
      returns: {
        "3Y": 33.1,
        "5Y": 37.5,
        "7Y": 32.8
    }
  },
  {
    id: 31,
    name: "ICICI Prudential Equity & Debt Fund",
    category: "Hedged Funds",
    rating: 4,
    returns: {
      "3Y": 15.6,
      "5Y": 18.2,
      "7Y": 16.5
    }
  },
  {
    id: 32,
    name: "HDFC Hybrid Equity Fund",
    category: "Hedged Funds",
    rating: 4,
    returns: {
      "3Y": 16.2,
      "5Y": 19.1,
      "7Y": 17.3
    }
  },
  {
    id: 33,
    name: "ICICI Prudential Technology Fund",
    category: "Sectoral Funds",
    rating: 4,
    returns: {
      "3Y": 30.1,
      "5Y": 35.2,
      "7Y": 31.8
    }
  }
];